import React from 'react';
import {COPY_STRINGS} from '../../constants/translatedCopy';
import { FEATURE_FLAGS } from '../../constants/featureFlags';
import { getUserData } from '../../services/API';
import { delay } from '../../services/util';

export default class GoModal extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      phase: -1,
    };
    this.incrementPhase = this.incrementPhase.bind(this);

    this.phases = [
      {
        text: COPY_STRINGS.ready,
        textClass: "",
        circleClass: "red",
        pronunciation: "<speak><prosody rate=\"90%\">" + COPY_STRINGS.ready + "?</prosody><break time=\"0.25s\"/></speak>",
        generativeSpeech: COPY_STRINGS.ready,
        step: 0,
      },
      {
        text: COPY_STRINGS.set,
        textClass: "",
        circleClass: "yellow",
        pronunciation: "<speak><prosody rate=\"80%\">" + COPY_STRINGS.set + "?</prosody><break time=\"0.25s\"/></speak>",
        generativeSpeech: COPY_STRINGS.set,
        step: 1,
      },
      {
        text: COPY_STRINGS.start_bang,
        textClass: "greenText",
        circleClass: "green",
        pronunciation: `<speak><break time=\"0.1s\"/><prosody pitch=\"high\" volume=\"loud\">"` + COPY_STRINGS.start_bang + `"</prosody></speak>`,
        generativeSpeech: COPY_STRINGS.generative_start,
        step: 2,
      },
    ];
  }

  componentDidMount(){
    this.incrementPhase();
  }

  async incrementPhase(){
    const { locale, bilingualLocale } = getUserData();
    const textLocale = bilingualLocale || locale;

    // We only use the new generative voice for English US
    const shouldUseGenerativeVoice = FEATURE_FLAGS.UNIVERSAL_GENERATIVE_VOICE && textLocale === "en-us";

    let nextPhase = this.state.phase + 1;

    if(nextPhase >= this.phases.length){
      this.props.callback && this.props.callback();
      return;
    }

    if (shouldUseGenerativeVoice && nextPhase !== 0) {
      // We use cause a delay programmatically for generative voice, since it does not use break tags
      await delay(250);
    }

    let phase = this.phases[nextPhase];
    let speechProps = {
      textToSpeak: shouldUseGenerativeVoice ? phase.generativeSpeech : phase.pronunciation,
      onEnd: this.incrementPhase,
      passThroughSpeechTags: true,
    };

    this.setState({
      phase: nextPhase,
    }, () => {
      this.props.speech.speak(speechProps);
    });
  }

  render() {
    return (
      <div className="goModal labelFontOverride">
        <div className="trafficLight">
          {this.phases.map((phase, index) => {
            let textClass = "inactive";
            let circleClass = "circle";
            if(this.state.phase >= phase.step){
              circleClass +=  ` ${phase.circleClass}`;
              textClass = phase.textClass ? phase.textClass : "";
            }
            return (
              <div key={index} className="light">
                <span className={"lightTitle  " + textClass}>{phase.text}</span>
                <span className={circleClass}></span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
